<template>
  <div class="grid pb-0">
    <div class="grid-title">
      <h4>{{ $t("CHAIN_AGENT_LIST") }}</h4>
       <!-- <v-btn color="primary" @click="addNew">
          <v-icon dark>
            mdi-plus
          </v-icon>
          {{ $t("ADD_NEW") }}
        </v-btn> -->
    </div>
    <div class="grid-body border-top-unset">
      <v-row align="center" class="pb-3 pl-3 pr-3">
        <v-col sm="4">
          <v-text-field
            v-model="keyword"
            :label="$t('ENTER_NAME_OR_CODE')"
            v-on:keyup="getAll(1)"
            class="mt-0 pt-0"
          ></v-text-field>
        </v-col>
        <v-col sm="8">
          <v-radio-group
            v-model="status"
            row
            class="mt-0"
            @change="getAll(1)"
          >
            <v-radio
              :label="$t('ALL')"
              value="all"
            ></v-radio>
            <v-radio
              :label="$t('ACTIVE')"
              value="1"
            ></v-radio>
            <v-radio
              :label="$t('DEACTIVE')"
              value="0"
            ></v-radio>
          </v-radio-group>
        </v-col>
      </v-row>
      <v-progress-linear
        color="warning"
        indeterminate
        rounded
        height="3"
        v-if="isLoading"
      ></v-progress-linear>
      <loading
        :active.sync="isLoadingPopup"
        :is-full-page="false"
      ></loading>
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th v-for="header in headers" :class="header.class">
                <div>
                  {{ header.text }}
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <template v-if="dataTable.length > 0 && !isLoading">
              <tr v-for="(item, i) in dataTable">
                <td class="text-center vertical-middle">{{ paging.offset + i + 1 }}</td>
                <td class="vertical-middle">
                  {{ item.travelAgentCode }}
                </td>
                <td class="font-weight-bold vertical-middle">
                  <a
                    class="app-link text-decoration-none"
                    href="javascript:;"
                    @click="editItem(item)"
                  >
                    {{
                      item.title
                    }}
                  </a>
                </td>
                <td class="vertical-middle">
                  {{ item.taxCode }}
                </td>
                <td class="vertical-middle">
                   {{ item.email }}
                </td>
                <td class="vertical-middle txt-nowrap">
                  {{ item.phone }}
                </td>
                <td class="vertical-middle text-break">
                  {{ item.address }}
                </td>
                <td class="text-center vertical-middle">
                  <div class="d-flex justify-center">
                    <v-switch
                      v-model="item.active"
                      class="item-switch m-0 p-0 align-center"
                      @change="$refs.changeStatusDialogComponent.open(item)"
                    ></v-switch>
                  </div>
                </td>
                <td class="text-center vertical-middle txt-nowrap">
                  <v-tooltip top transition="slide-y-reverse-transition">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        depressed
                        @click="editItem(item)"
                        x-small
                        class="rounded-sm mr-1"
                        v-bind="attrs"
                        v-on="on"
                        color="primary"
                        outlined
                      >
                        <v-icon size="15">
                          mdi-pencil
                        </v-icon>
                      </v-btn>
                    </template>
                    {{ $t("EDIT") }}
                  </v-tooltip>
                  <v-tooltip top transition="slide-y-reverse-transition">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        depressed
                        color="error"
                        @click="$refs.deleteDialogComponent.open(item)"
                        x-small
                        v-bind="attrs"
                        v-on="on"
                        class="rounded-sm mr-1"
                        outlined
                      >
                        <v-icon size="15">
                          delete
                        </v-icon>
                      </v-btn>
                    </template>
                    {{ $t("DELETE") }}
                  </v-tooltip>
                </td>
              </tr>
            </template>
            <template v-else>
              <tr>
                <td colspan="8" class="text-center vertical-middle font-weight-bold font-italic" style="color:red">
                  {{ $t('NO_DATA') }}
                </td>
              </tr>
            </template>
          </tbody>
        </template>
      </v-simple-table>
      <b-row>
        <b-col>
            <paging
                v-if="paging.total"
                :paging.sync="paging"
                @changePage="changePage"
                class="pl-3 pr-3"
              >
                <span slot="totalItems" v-if="paging"
                  >{{ $t("TOTAL") }}: {{ paging.total }}</span
                >
              </paging>
        </b-col>
      </b-row>

      <delete-dialog @deleteItem="deleteItem" ref="deleteDialogComponent">
        <span slot="title"
          >{{ $t("CONFIRM_DELETE_ROOM") }}?</span
        >
      </delete-dialog>
      <confirm-dialog
        @deleteItem="changeStatusItem"
        @cancelDelete="cancelDelete"
        :maxWidth="370"
        :persistent="true"
        ref="changeStatusDialogComponent"
      >
        <span slot="title"
          >{{ $t("_TRAVEL_AGENT.CONFIRM_CHANGE_ACTIVE") }}</span
        >
      </confirm-dialog>
    </div>
  </div>
</template>

<script>
import Paging from "@/components/Utils/Paging.vue";
import DeleteDialog from "@/components/Utils/DeleteDialog.vue";
import ConfirmDialog from "@/components/Utils/ConfirmDialog.vue";
import draggable from "vuedraggable";
import { agentService } from "@/_services/HotelSetting/agent.service.js";
import { _formatCurrency, _formatDate, _alert } from "@/_helpers/function.js";
export default {
  components: {
    "delete-dialog": DeleteDialog,
    "confirm-dialog": ConfirmDialog,
    paging: Paging,
    draggable
  },
  data() {
    return {
      currency: null,
      isLoading: true,
      isLoadingPopup: false,
      systemLang: this.$i18n.locale,
      isListingPage: true,
      dialog: false,
      sortDesc: true,
      headers: [
        {
          text: this.$t("STT"),
          class: "text-center"
        },
        {
          text: this.$t("TA_CODE"),
          value: "roomCode",
        },
        {
          text: this.$t("TA_NAME"),
          value: "name",
        },
        {
          text: this.$t("_CONTRACT.TAX_CODE"),
          value: "defaultPrice"
        },
        {
          text: this.$t("EMAIL"),
          value: "weekendRate"
        },
        {
          text: this.$t("_ACCOUNT_SETTING.PHONE_NUMBER"),
          value: "maxCustomers",
          class: "text-left"
        },
        {
          text: this.$t("ADDRESS"),
          value: "totalRooms",
          width: "13%"
        },
        {
          text: this.$t("STATUS"),
          class: "text-center",
          value: "status",
        },
        {
          text: this.$t("ACTION"),
          class: "text-center"
        }
      ],
      data: [],
      dataTable: [],
      selected: [],
      editedIndex: -1,
      editedItem: null,
      keyword: "",
      status: "all",
      paging: {
        total: 0,
        limit: 15,
        offset: 0
      },
      orderBy: "active",
      asc: false
    };
  },
  created() {
    this.currency = this.usedCurrency;
    this.initialize();
  },
  watch: {},
  methods: {
    initialize() {
      this.getAll();
    },
    changeOrderList() {
      let tmp = [];
      setTimeout(() => {
        tmp = this.dataTable.map(e => {return e.roomId});
        service.sortIndexRoom(tmp).then(res => {
          if (res.responseCode !== 0) {
            this.initialize();
          }
          _alert(res, this.$t(res.data), false);
        });
      }, 500);
    },
    getAll(isSearching) {
      if (isSearching) this.paging.offset = 0;
      let body = {};
      body.keyword = this.keyword;
      if (this.status === "all") {
        body.status = null;
      } else {
        body.status = this.status;
      }
      body.limit = this.paging.limit;
      body.offset = this.paging.offset;
      body.orderBy = this.orderBy;
      body.asc = this.asc;
      this.isLoading = true;
      agentService.getAllTravelAgent(body).then(res => {
        this.data = res.data;
        this.dataTable = res.data;
        this.paging.total = res.total;
      }).finally(() => (this.isLoading = false));
    },
    changePage(paging) {
      this.paging = paging;
      this.getAll();
    },
    sortStatus(asc, isSearching) {
      if (asc) {
        this.asc = false;
      } else {
        this.asc = true;
      }
      this.getAll(isSearching);
    },
    addNew() {
      this.$router.push({
        name: "agent-infomation",
        params: { id: "00000000-0000-0000-0000-000000000000" }
      });
    },
    editItem(item) {
      this.$router.push({
        name: "agent-infomation",
        params: { id: item.id }
      });
    },
    cancelDelete( item ) {
      item.active = !item.active;
    },
    deleteItem(item) {
      agentService.removeAgent(item.id).then(res => {
        if (res.responseCode == 0) {
          this.initialize();
        }
        _alert(res, this.$t(res.data), false);
      });
    },
    changeStatusItem(item) {
      this.isLoadingPopup = true;
      this.changeStatus(item);
    },
    changeStatus(item) {
      let body = {
        id: item.id,
        status: item.active ? 1 : 0
      };
      agentService.updateStatus(body).then(res => {
        if (res.responseCode === 1) item.active = !item.active;
        _alert(res, this.$t(res.data), true);
      });
    },
    _formatCurrency: _formatCurrency
  }
};
</script>
